import type { Milestone } from './constants.js';

export function formatNum(n: number): string {
  if (n >= 1000) return n.toLocaleString();
  return n.toString();
}

export function formatVal(m: Milestone): string {
  const p = m.prefix || '';
  const s = m.suffix || '';
  if (m.format === 'decimal') return `${p}${m.current}${s}`;
  if (m.format === 'percent')
    return `${m.current % 1 === 0 ? m.current : m.current.toFixed(1)}${s}`;
  if (m.format === 'currency') return `${p}${m.current.toLocaleString()}`;
  return `${p}${formatNum(m.current)}${s}`;
}

export function formatTarget(m: Milestone): string {
  const p = m.prefix || '';
  const s = m.suffix || '';
  if (m.format === 'decimal') return `${p}${m.target}${s}`;
  if (m.format === 'percent') return `${m.target % 1 === 0 ? m.target : m.target.toFixed(1)}${s}`;
  if (m.format === 'currency') return `${p}${m.target.toLocaleString()}`;
  return `${p}${formatNum(m.target)}${s}`;
}

export function normalizeSurgeonName(name: string): string {
  return name
    .replace(/^(dr\.?|mr\.?|ms\.?|mrs\.?|miss|prof\.?)\s+/i, '')
    .replace(/,?\s*(md|do|phd|facs|frcs|m\.d\.|d\.o\.)\.?$/i, '')
    .trim()
    .toLowerCase();
}

export function getInitials(name: string): string {
  return name
    .split(' ')
    .filter((n) => n.length > 1 && n.charAt(0) === n.charAt(0).toUpperCase())
    .slice(-2)
    .map((n) => n.charAt(0))
    .join('');
}
